import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

const isDemoMode = import.meta.env.VITE_DEMO_MODE === 'true';

async function bootstrap() {
  let AppComponent: React.ComponentType;

  if (isDemoMode) {
    // Demo mode: install mock fetch, use mock auth/UI
    // authHelper.ts checks VITE_DEMO_MODE and returns a demo token
    const { installDemoFetch } = await import('./mocks/demoFetch');
    installDemoFetch();
    const { default: DemoApp } = await import('./DemoApp');
    AppComponent = DemoApp;
    console.info(
      '%c🎭 Demo Mode Active%c — switch roles using the toolbar at bottom-right',
      'color: #d97706; font-weight: bold; font-size: 14px',
      'color: #92400e; font-size: 12px',
    );
  } else {
    // Production mode: configure Amplify and use real auth
    const { configureAmplify } = await import('./config/amplify');
    configureAmplify();
    const { default: App } = await import('./App');
    AppComponent = App;
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <AppComponent />
      </BrowserRouter>
    </React.StrictMode>,
  );
}

bootstrap();

